import React, { useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import "./informe.css";

const Informe = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container beneficiarios-container">
      <div className='row'>
            <div className='col_12'>
                <div className='beneficiarios_title'>
                    <h1>3ER INFORME DE GOBIERNO</h1>
                </div>
            </div>

             {/* Cards 1*/}
      {/* <div className="row g-4 mb-5">
        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/informe/1.jpg"
              className="card-img-top"
              alt="Imagen 1"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/Informe/2.jpg"
              className="card-img-top"
              alt="Imagen 2"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/Informe/3.jpg"
              className="card-img-top"
              alt="Imagen 3"
            />
          </div>
        </div>
      </div> */}

       {/* Cards 2*/}
      {/* <div className="row g-4 mb-5">
        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/informe/4.jpg"
              className="card-img-top"
              alt="Imagen 1"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/Informe/5.jpg"
              className="card-img-top"
              alt="Imagen 2"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/Informe/6.jpg"
              className="card-img-top"
              alt="Imagen 3"
            />
          </div>
        </div>
      </div> */}
      {/* Cards 3*/}
      {/* <div className="row g-4 mb-5">
        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/informe/7.jpg"
              className="card-img-top"
              alt="Imagen 1"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/Informe/8.jpg"
              className="card-img-top"
              alt="Imagen 2"
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow h-100">
            <img
              src="/img/Informe/9.jpg"
              className="card-img-top"
              alt="Imagen 3"
            />
          </div>
        </div>
      </div> */}
      <div className="mb-5">
        <h2 className="mb-4">Comparecencia </h2>
         <div className="row g-4">
          {/* Video 1 */}
          <div className="col-md-12">
            <div className="card shadow h-100">
              <div className="card-body">
                {/* <h5 className="card-title">Testimonios</h5> */}
                <div>
                  <iframe
                  // type="application/pdf"
                  src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/DocsPagweb/ComparecenciaSADERH2025.pdf"
                  height="1500"
                  width="1110"></iframe>
                  </div>
                {/* <div className="ratio ratio-16x9">
                  <video controls autoPlay muted>
                    {/* <source src="/video/Testimonios2024.mp4" type="video/mp4" />  Tu navegador no soporta el video.</video>
                </div> */}
              </div>
            </div>
          </div>


         </div>



      </div>



        </div>

      <hr className="hr-gob" />
    </div>
  );
};

export default Informe;
